import { render, staticRenderFns } from "./EasypostSection.vue?vue&type=template&id=867f2552&scoped=true"
import script from "./EasypostSection.vue?vue&type=script&lang=js"
export * from "./EasypostSection.vue?vue&type=script&lang=js"
import style0 from "./EasypostSection.vue?vue&type=style&index=0&id=867f2552&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "867f2552",
  null
  
)

export default component.exports